
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "TAOWAERFVLF",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/TAOWAERFVLF.vue